import { Box, Flex } from '@chakra-ui/react';
import ExpertiseBox from '../components/ExpertiseBox';
import { FaReact, FaDesktop, FaFigma } from "react-icons/fa";

const Expertise = () => {
    const expertiseData = [
        {
            title: "Project Management",
            text: "Coordinating teams/managing client relationships to deliver successful software projects.",
            color: "blue.300",
            icon: <FaDesktop />,
        },
        {
            title: "UI/UX Design & Discovery",
            text: "Designing user-friendly interfaces and experiences using Figma and conducting user research.",
            color: "green.100",
            icon: <FaFigma />,
            isMiddle: true,
        },
        {
            title: "Software Development",
            text: "Building beautiful, responsive, and performant apps with React and TypeScript.",
            color: "blue.100",
            icon: <FaReact />,
        },
    ];

    return (
        <Flex
            flexDirection={"column"}
            alignItems="center"
            justifyContent="space-between"
            padding="5%"
            paddingLeft={"10%"}
            paddingRight={"10%"}
            backgroundColor={"black.200"}
            minW={"100%"}
        >
            {/* Title */}
            <Box
                fontSize={"4xl"}
                fontFamily={"Source Code Pro Variable"}
                fontWeight="600"
                width={"100%"}
                textAlign={"center"}
                color={"white.200"}
                marginBottom={"2%"}
            >
                What Do I Do?
            </Box>

            {/* List of Skills */}
            <Flex
                flexDirection={{ base: "column", md: "row" }}
                alignItems="center"
                justifyContent="center"
                width={"100%"}
                gap={{ base: "5", md: "0" }}
            >
                {expertiseData.map((item, index) => (
                    <ExpertiseBox
                        key={index}
                        index={index}
                        title={item.title}
                        text={item.text}
                        color={item.color}
                        icon={item.icon}
                        isMiddle={item.isMiddle}
                    />
                ))}
            </Flex>
        </Flex>
    );
};

export default Expertise;
